import { ProjectModule } from "@/store/modules/project.module";
import { toaster } from "@/utilities/toaster";
import { Machine } from "xstate";
const projectAnalyticsMachine = Machine({
    id: "projectAnalyticsMachine",
    context: {
        selectedFilters: "AccessibleToMe",
    },
    initial: "idle",
    states: {
        idle: {
            always: {
                target: "gettingProjectList",
            },
        },
        gettingProjectList: {
            tags: "gettingProjectList",
            invoke: {
                id: "gettingProjectList",
                src: (context, event) => {
                    return ProjectModule.GetProjectsHierarchicalList(context.selectedFilters);
                },
                onDone: { target: "loadedProjectList" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedProjectList: {
            tags: "gettingProjectList",
            on: {
                PROJECT_ANALYTICS_FILTERS: { target: "gettingProjectList" },
            },
        },
        serviceUnavailable: {
            type: "final",
        },
    },
}, {
    actions: {
        showSuccessMessage: (context, event) => {
            toaster.ShowSuccess(event.data.successMessages[0]);
        },
    },
    guards: {},
    activities: {},
    services: {},
});
export default projectAnalyticsMachine;
